<label class="liveEdit" [ngClass]="{'liveEdit_empty': isEmpty(), 'liveEdit_focused': focused }" [attr.data-content]="getData()">
    <textarea maxlength="" [(ngModel)]="inputData" (focus)="onFocus()" (blur)="onBlur()" (keydown.enter)="false"></textarea>
    <span class="liveEdit__trigger"><span class="sr-only">{{ 'words.edit' | translate }}</span></span>
</label>